import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeatureGrid from "./components/FeatureGrid";
import TrackingSection from "./components/TrackingSection";
import ReviewSection from "./components/ReviewSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <TrackingSection />
        <ReviewSection />
      </main>
      <Footer />
    </div>
  );
}